define('prints',["shims"], function() {

  //die on non-tablet
  try {
    document.createEvent("TouchEvent");
    if (window.matchMedia && window.matchMedia("(max-width: 480px)").matches) throw "No prints on phones";
  } catch (_) {
    return;
  }

  var canvas = document.createElement("canvas");
  document.body.insertBefore(canvas, document.body.firstChild);
  canvas.className = "smear";
  // canvas.style.backgroundColor = "pink";

  var context = canvas.getContext("2d");

  var print = new Image();
  print.src = "../assets/print.png";

  canvas.width = window.innerWidth * .5;
  canvas.height = window.innerHeight * .5;

  var splat = 20;
  var splatSize = 7;

  var rgba = function(r, g, b, a) { return "rgba(" + [r,g,b,a].join() + ")" };

  var project = function(x, y) {
    return {
      x: x * canvas.width / canvas.offsetWidth,
      y: y * canvas.height / canvas.offsetHeight
    };
  };

  var drawPrint = function(x, y, alpha) {
    alpha = alpha || 1;
    context.globalAlpha = alpha * .3;
    var projection = project(60, 90);
    context.drawImage(print, x - projection.x * .5, y - projection.y * .5, projection.x, projection.y);
  };

  var splatter = function(x, y, alpha) {
    if (typeof alpha == "undefined") alpha = 1;
    var pixel = project(2, 2);
    context.fillStyle = rgba(0, 0, 0, alpha * .4);
    for (var i = 0; i < splat; i++) {
      var distance = Math.random() * splatSize;
      var angle = Math.random() * Math.PI * 2;
      var cx = x + Math.sin(angle) * pixel.x * distance;
      var cy = y + Math.cos(angle) * pixel.y * distance;
      context.fillRect(cx, cy, pixel.x, pixel.y);
    }
  };

  var fadeCounter = 0;

  var fade = function() {
    context.globalAlpha = 1;
    var opacity = .05;
    context.fillStyle = rgba(255, 255, 255, opacity);
    context.fillRect(0, 0, canvas.width, canvas.height);
    if (fadeCounter > 1.5 / opacity) {
      //reset and halt
      fadeCounter = 0;
    } else {
      fadeCounter++;
      window.requestAnimationFrame(fade);
    }
  };

  var fadeTimeout = null;

  var scheduleFade = function() {
    if (fadeTimeout) {
      clearTimeout(fadeTimeout);
    }
    if (!fadeCounter) {
      fadeTimeout = setTimeout(fade, 1000);
    }
  };

  var touchstart = function(e) {
    for (var i = 0; i < e.touches.length; i++) {
      var touch = e.touches[i];
      var projected = project(touch.clientX, touch.clientY);
      drawPrint(projected.x, projected.y);
    }
    scheduleFade();
  };

  document.addEventListener("touchstart", touchstart);

});
